module.exports = __webpack_public_path__ + "img/icon-linkedin-gray.35268b47.svg";